import { render, staticRenderFns } from "./ProductServiceCategoryGroupEdit.vue?vue&type=template&id=2180a2a4&"
import script from "./ProductServiceCategoryGroupEdit.js?vue&type=script&lang=js&"
export * from "./ProductServiceCategoryGroupEdit.js?vue&type=script&lang=js&"
import style0 from "./ProductServiceCategoryGroupEdit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports